<input
  type="text"
  [placeholder]="placeholder"
  (keydown)="onValueChanged()"
  (keydown.enter)="$event.preventDefault()"
  autocorrect="off"
  autocapitalize="off"
  spellcheck="off"
  type="text"
  (focusout)="onFocusOut()"
  #search
  [formControlName]="controlName"
  [ngClass]="{'remove-style': removeStyle, 'form-control': !removeStyle}">
